export const environment = {
  production: true,
  environmentName: 'prod',
  backendUrl: 'https://smartbookingmanager.passepartout.cloud/sbmapi/api'
};